import React from 'react';
import { gettext, dangerousGettext } from '@eventbrite/i18n';
import { getHost, getLocale } from './utils';
import { getPricesForTLD } from './pricingAndPackagingUtils';
import './InfoCards.scss';

const getInfoCards = () => {
    const priceMapping = getPricesForTLD();
    const locale = Intl.NumberFormat().resolvedOptions().locale;
    return [
        {
            headerText: gettext("It's free to get started"),
            bodyContent: (
                <>
                    <p
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{
                            __html: dangerousGettext(
                                "<b>It's free to publish events with up to 25 tickets.</b>  You can add more tickets with plans starting at %(startingPrice)s.  This fee can be paid from your ticket sales, so there are no upfront costs to you.",
                                {
                                    startingPrice:
                                        priceMapping.flexPlan.liteTier,
                                },
                            ).toString(),
                        }}
                    />
                    <p>
                        {gettext(
                            'If you host a lot of events, our Eventbrite Pro subscription can save you money while helping you grow.',
                        )}
                    </p>
                </>
            ),
        },
        {
            headerText: gettext("We're honest about our fees"),
            bodyContent: (
                <>
                    <p
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{
                            __html: dangerousGettext(
                                "<b>We charge you a fee to publish based on the size and frequency of your events</b>, and you'll always know how much you're spending.  This helps us give you everything you need to stand out and earn more from your events.",
                            ),
                        }}
                    />
                    <p
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{
                            __html: dangerousGettext(
                                "Attendees see <a href='%(ticketingFeesUrl)s' target='_blank'>Ticketing Fees</a> when purchasing a ticket.  However, you have the option to cover these fees and have them deducted from your ticket sales.",
                                {
                                    ticketingFeesUrl: `https://${getHost()}/help/${locale.toLowerCase()}/articles/755615`,
                                },
                            ),
                        }}
                    />
                </>
            ),
        },
        {
            headerText: gettext("You're in control"),
            bodyContent: (
                <>
                    <p
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{
                            __html: dangerousGettext(
                                '<b>Choose how many tickets you sell, how much they cost, and how you promote your event.</b>  You can always offset the cost of your fee by accounting for it in your ticket price.',
                            ),
                        }}
                    />
                    <p
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{
                            __html: dangerousGettext(
                                "Check out our <a href='%(pricingGuideUrl)s' target='_blank'>Ultimate Ticketing Pricing</a> guide to learn more about setting competitive prices for your event.",
                                {
                                    pricingGuideUrl: `https://${getHost()}/blog/asset/ultimate-ticket-pricing-guide-eventbrite/`,
                                },
                            ),
                        }}
                    />
                </>
            ),
        },
    ];
};

export const InfoCard = ({ headerText, bodyContent }) => {
    return (
        <div className="pricing-and-packaging-info-card">
            <h2 className="info-card-header">{headerText}</h2>
            <div className="info-card-content">{bodyContent}</div>
        </div>
    );
};

export const InfoCards = () => {
    return (
        <div className="pricing-and-packaging-cards">
            {getInfoCards().map((cardProps, i) => (
                <InfoCard key={i} {...cardProps} />
            ))}
        </div>
    );
};

export default InfoCards;
